const checkIfCompanyDataIsNull = companyData => {
  if (!companyData || !companyData.value) {
    return null;
  }
  return companyData;
};

export default checkIfCompanyDataIsNull;
